<template>
  <div class="main-cont container">
    <!-- <div class="title"> -->
    <h4 class="title">My Builds  <span v-if="getUserBuilds &&  getUserBuilds!==null" style="color: #1997c6">({{getUserBuilds.length}})</span></h4>
    <hr style="margin-top: 0px;" />
    <!-- MAIN FRAME -->
    <div class="ord-main">
      <div  class="row">
        <div v-if="ifBuildsLoaded " class="col-sm-12">
          <div  @click="selectBuild(build.id)" v-for="build in getUserBuilds" :key="build.id" class="row build">
            <!-- IMAGE -->
            <div style="opacity: 0.95" :style="{backgroundImage: 'url(' + build.image + ')'}" class="col-sm-4 sample prds-info">
            </div>
            <!-- Right Side -->
            <div  class="col-sm-5" style=";">
              <!-- Build Name -->
              <div class="" style="letter-spacing: 2px;border-bottom: 1px solid #9198aa; font-size: 20px; color: #1997c6; margin-left: 10px; margin-right: -80px; margin-bottom: 10px;">
               {{build.name}}
              </div>
              <!-- Build Parts List -->
              <div v-for="(index1, item) in build" :key="index1">
                <!-- <div v-if="typeof(index1) == 'object'">{{build}}</div> -->
                <div class="items" 
                  :class="{
                    'inactive': typeof(JSON.parse(build[`${item}_id`])) !== 'number' 
                    && typeof(JSON.parse(build[`${item}_id`])) !== 'object'}" 
                    style="margin-left: 10px;text-transform: capitalize; " 
                    v-if="!fieldExceptions.includes(item) && !item.includes('_') ">
                  {{item}}
                  <!-- IF RAM STORAGE OR GPU -->
                  <div v-if="index1 !==null && typeof(build[`${item}_id`]) == 'string'" style="float: right;" >
                    <span style="margin-right: 15px;">
                      <span style="color: #1997c6">
                        <div v-if="JSON.parse((build[`${item}_id`])).length >1" style="white-space: nowrap; display: inline-block; width: 215px;">
                          <span v-if="index1[0].type == 'ram'" style="color: #1997c6;">{{index1[0].compat.ram_type + ' ' + getItemValue({item:index1, field: 'capacity'})}}</span> <span style="color:#00bc8c"  v-if="index1[0].type == 'ram'"> ({{index1.length}}) </span>
                          <span v-if="index1[0].type == 'storage'" style="color: #1997c6;">{{getItemValue({item:index1, field: 'capacity'})}}</span> <span style="color:#00bc8c"  v-if="index1[0].type == 'storage'"> ({{index1.length}}) </span>
                          <span v-if="index1[0].type == 'graphics'" style="color: #1997c6;">{{index1[0].model}}</span> <span style="color:#00bc8c" v-if="index1[0].type == 'graphics'"> ({{index1.length}}) </span>
                        </div>
                        <div v-else style="white-space: nowrap; display: inline-block; width: 215px;">
                          <span style="color: #1997c6;">{{index1[0].model}}</span><span style="color: #00bc8c"> ({{index1.length}}) </span>
                        </div>
                        <div class="item-price ">
                          <span style="margin-left; 200px !important; color: #cfd2da"><span style="float: left; color: #9198aa">$</span>{{get_amzn_price_sum(index1).toFixed(2) }}</span>
                        </div>
                      </span>
                    </span>
                  </div>
                  <!-- ELSE -->
                  <div v-if="index1 !==null && typeof(build[`${item}_id`]) == 'number'" style="float: right;" >
                    <div style="display: inline-block; width: 230px;">
                      <span style=" color: #1997c6;">{{index1.model}}</span> 
                    </div>
                    <div class="item-price">
                          <span style="margin-left; 200px !important; color: #cfd2da"><span style="float: left; color: #9198aa">$</span>{{index1.amzn_price }}</span>
                        </div>
                    <!-- <span style="position:absolute; right: -55px;">{{'$ '+ index1.amzn_price }}</span> -->
                  </div>
                </div>
              </div>
            </div>
            <!-- STATUS BAR -->
            <div  class="col-md-3 buttons-section" style="vertical-align: bottom;">
              <!-- <div v-if="build.status == 'incomplete'" style="vertical-align: bottom;" class="status-indicator">
                <span style="color: rgb(225, 212, 32)" class="icon icon-new"></span>
                {{build.status}}
              </div> -->
              <div>
                  <button @click="loadBuild(build)" style="width: 30px; height: 30px; border: none; background: transparent" class="gc-button"><i class="fa fa-edit"></i></button>                
                  <button @click="()=>{removeBuild = true}" style="width: 30px; border: none;" class="gc-button delete-button"><i class="fa fa-trash"></i></button>
              </div>
               
                <div v-if="removeBuild && build.id == clickedBuild" class="confirm">
                  <div>
                    <span>Are you sure?</span>
                    <div>
                      <button v-if="!ifProcessing" @click="rmBuild(build.id)" style="border: none; margin: 0px;" class="gc-button">Yes</button>
                      <button v-if="ifProcessing" style="border: none; margin: 0px;" class="gc-button">Deleting</button>
                    </div>
                    <div>
                      <button style="border: none; margin: 0px;" @click="()=>{removeBuild = false}" class="gc-button">Cancel</button>
                    </div>
                  </div>
                </div>
            </div>
            <!-- Price BAR -->
            <div class="price-bar">
              <div style="float: right">
                <span style="opacity: 0.8" >SubTotal:  </span> 
                <span style="margin-right: 100px;"> 
                  <span class="price"><span style="font-size: 16px;">$</span>{{countBuildCost(build)}}</span>
                </span>
                <button style="width: unset; max-width: unset; text-transform: unset; padding: 5px 10px;" class="gc-button">Buy on Amazon.com</button>
              </div>
            </div>
          </div>
        </div>
        <div v-else style="width: 100%; position: relative; min-height: 800px;">
          <Loader style="position: absolute;"/>
        </div>
      </div>    
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader                     from '../widgets/loader.vue'
export default {
  name: "MyBuild",
  components: {
    Loader
  },
  data() {
    return {
      removeBuild :false,
      clickedBuild: '',
      fieldExceptions: [
        'name',
        'accessories',
        'image',
        'id',
        'author_id',
        'cost',
        'status'
      ],
      builds: [
        {
          image:{
            sample: require('../../assets/amd.jpg')
          },
          img: "../../assets/amd.jpg",
          description: "Info about product and the link which takes user back to product",
          amzn_price: "99.95",
          neg_price: "105.99",
        },
        {
          image:{
            sample: require('../../assets/amd.jpg')
          },
          img: "../../assets/amd.jpg",
          description: "Info about product and the link which takes user back to product",
          amzn_price: "99.95",
          neg_price: "105.99",
        },
      ],
    };
  },
  methods: {
    ...mapActions([
      'fetchUserBuilds',
      'rmBuild',
      'loadBuild'
    ]),
    getItemValue({item, field}){
      console.log('getting item value: ', field, ' from ', item)
      var type = ''
      var length = 0
      var capacity = 0
      var parsedItem = item

      if(parsedItem && typeof(parsedItem) == 'object' && item.length >0){
        type = parsedItem[0].type
        length = parsedItem.length
      }
      else {
        type = parsedItem.type
      }
      if(type == 'ram'){
        if(field == 'capacity'){
          capacity = 0
          if(length >0){
            parsedItem.map((itm) => capacity += parseInt(itm.compat.capacity))
          }
          return capacity + ' GB'
        }
      }
      if(type == 'storage'){
        if(field == 'capacity'){
          capacity = 0
          if(length >0){
            parsedItem.map((itm) => capacity += parseInt(itm.specs.Capacity))
          }
          return capacity + ' TB'
        }
      }
      if(type == 'graphics' || type == 'gpu'){
        if(field == 'model'){
          var model = parsedItem.model || ''
          if(length >0){
            model = parsedItem[0].model
          }
          console.log('got model: ', model)
          return model
        }
      }
    },
    selectBuild(id){
      this.clickedBuild = id
    },
    countBuildCost(build){
      var total = 0;
      for (var prop in build){
        if(!this.fieldExceptions.includes(prop) && !prop.includes('_') ){
          if(build[prop] !==null && typeof(build[prop].amzn_price) == 'string'){
            total += parseFloat(build[prop].amzn_price)
          }
          else if(build[prop] !==null && typeof(build[prop]) == 'object' && build[prop].length >0){
            build[prop].map((item) => {
              if(typeof(item.amzn_price) == 'string'){
                total += parseFloat(item.amzn_price)
              }
            })
            console.log(prop, 'is an array')
          }
        }
      }
      return total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    get_amzn_price_sum(items){
      var total = 0;
      for (var i = 0; i< items.length; i++){
        if (typeof(items[i].amzn_price) == 'string') {
          total += parseFloat(items[i].amzn_price)
        }
      }
      return total
    }
  },
  computed: {
    ...mapGetters([
      "getUser",
      'getUserBuilds',
      'ifProcessing',
      'ifBuildsLoaded',
      ]),
  },
  created() {
    console.log('get user builds ', this.getUserBuilds)
    console.log(this.fetchUserBuilds(this.getUser.id))
    this.data = {
      email: this.email,
      username: this.username,
      first_name: this.first_name,
      last_name: this.last_name,
      img_url: this.img_url,
    };
    console.log(this.data);
  },
};
</script>

<style scoped>
@import "../../assets/css/dashboard.css";
.item-price {
  display:inline-block; 
  position: absolute; 
  right: -55px; 
  min-width: 65px; 
  text-align: right;
}
.items {
  padding: 1px;
}
.build {
  padding: 12px;
  margin-right: 15px;
  margin-bottom: 15px;
  border-radius: 6px;;
  border: 1px solid #434857;
}
#checkout {
  vertical-align: bottom;
  border: 1px solid #434857;
  max-width: 305px;
  padding: 1rem;
  border-radius: 6px;
  float: right;
}
.checkout-div {
  border: 1px solid #434857;
  width: 100%;
  height: 80px;
  border-radius: 6px;
  margin: 10px;
}
.shop-option {
  border: 1px solid white;
  border-radius: 6px;
  text-align: center;
}
#quantity {
  background: #9198aa;
  width: 50px;
  height: 25px;
  padding: 1px 3px;
}
.checkout-btn {
  width: 17rem;
  padding: 0;
}
.checkout-btn:hover {
  color: #cfd2da;
}
.subtotal {
  color: #1bc98e;
}
.confirm {
  display: inline-block;
  text-align: center;
  right: 0px;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0px 0px 4px #cfd2da;
  max-width: 120px;
  min-height: 120px;
  opacity: 0.95;
  background-color: #434857;
}
.title {
  text-align: center;
}
.txt-align-left {
  margin-left: 10rem !important;
}
.txt {
  font-size: 1rem;
}
.rt-txt {
  margin-left: 0.8rem;
}
.price {
  color: #e4d836;
   opacity: 0.9;
}
.sample {
    border-radius: 6px;
    background-position-x: center;
    background-position-y: center;
    background-color: white;
    width: 100%;
    height: 200px;
    background-repeat: no-repeat;
    background-size: auto 100%;
    margin-top: 0.4rem;
    box-shadow: inset 0 0 10px #191b20
}
hr {
  border-top: 1px solid #9198aa;
}

.ord-main {
  padding: 0 0 0 0.8rem;
  overflow: scroll;
  overflow-x: hidden;
}

.mid-row {
  margin-top: 0.3rem;
}
.price-bar {
  border-top: 1px solid #9198aa;
  padding-top: 5px;;
  display: block;
  width: 100%;
  margin-top: 15px;
}
.row-lst {
  margin-top: 1rem !important;
}
.price{
  font-size: 20px;
}
.inactive {
  opacity: 0.5;
}
.buttons-section {
  text-align: right;
  vertical-align: bottom;
}
.status-indicator {
  font-size: 16px;
  text-transform: capitalize;
  border-radius: 6px;
  padding: 5px;
  opacity: 0.8;
}
</style>
<style lang="css">
.main-cont {
  width: 100%;
  display: inline-block;
  margin-left: 0px !important;
  padding-bottom: 20px !important;
}
</style>